import classNames from 'classnames'
import style from './ProgressBarAnimated.module.scss'

const ProgressBarAnimated = ({ barStyle, progressStyle, achieved, failed }) => {
  const offsetX = isNaN(achieved) || achieved < 0
    ? 100
    : achieved >= 100
      ? 0
      : 100 - achieved

  return (
    <div className={classNames(style.bar, barStyle)}>
      <div className={classNames(style.progress, progressStyle, failed && style.failed)} style={{transform: `translateX(-${offsetX}%)`}}></div>
    </div>
  )
}

export default ProgressBarAnimated